import { Screen } from '~/screens/ServiceReport';

export const ServiceReport = () => <Screen />;
